import axios from "axios";
import { BASE_URL } from "../../enums/ApiPaths";
import { getBearerToken } from "../Functions";

const api = axios.create({
  baseURL: BASE_URL,
});

// Request interceptor — attach headers
api.interceptors.request.use(async (config) => {
  // sessionStorage is only written by the language switcher - fall back to the persisted
  // choice so the backend (e.g. for mails) still gets the language the UI is shown in
  config.headers["Accept-Language"] =
    sessionStorage.getItem("lang") || localStorage.getItem("lang");
  const bearer = await getBearerToken();
  if (bearer) {
    config.headers["Authorization"] = bearer.Authorization;
  }

  return config;
});

export default api;